import React from 'react';
import { createComponent } from '@lit/react';
import { IxDivider as LitComp } from '../IxDivider.js';

customElements.define('ix-divider', LitComp);

export const IxDivider = createComponent({
  tagName: 'ix-divider-react',
  elementClass: LitComp,
  react: React,
});
